export default __webpack_public_path__ + "static/media/logo-ae-crate-and-barrel.58c9c36a.svg";